import React, { useState, useEffect } from "react";
import FloatingSidebar from "./../../organisms/FloatingSidebar";
import Header from "./../../organisms/Header";
import "./style.css";

const MainTemplate = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(
    localStorage.getItem("isSideBarOpen") === "true"
  );

  useEffect(() => {
    const handleSidebarChange = () => {
      setIsExpanded(localStorage.getItem("isSideBarOpen") === "true");
    };

    window.addEventListener("sidebarChange", handleSidebarChange);
    
    return () => {
      window.removeEventListener("sidebarChange", handleSidebarChange);
    };
  }, []);

  return (
    <div className="app-shell">
      <Header />
      <div className="app-container">
        <FloatingSidebar />
        <main 
          className={`main-content ${isExpanded ? "expanded" : "collapsed"}`} 
          id="main-app"
        >
          <div className="content-inner">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainTemplate;
